import { Box, Grid } from "@material-ui/core";
import PropertyPhotosGallery from "./propertyPhotosGallery";
import SubjectPropertyInfo from "./subjectPropertyInfo";
import { useStore } from "@roc/client-portal-shared/hooks";
import { observer } from "mobx-react";
import { AllPropertyPhotosGallery } from "./allPropertyPhotosGallery";

const SubjectPropertyView = observer(() => {
  const { compToolStoreV2: compToolStore } = useStore();
  const subjectProperty = compToolStore.subjectProperty;

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={12} lg={5}>
        <Box display="flex" flexDirection="column" gridGap="8px">
          <PropertyPhotosGallery propertyId={subjectProperty.property_id} images={subjectProperty.data.images} roundedBorders height="330px" />
          <AllPropertyPhotosGallery property={subjectProperty} />
        </Box>
      </Grid>
      <Grid item md={12} lg={7}>
        <SubjectPropertyInfo subjectProperty={subjectProperty} />
      </Grid>
    </Grid>
  );
});

export default SubjectPropertyView;
